// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1JRIv","large":"styles_large__3B49q"};